<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="名称">
        <el-input type="textarea" v-model ="formData.text"></el-input>
      </el-form-item>

      <el-form-item label="分支条件">
        <el-input type="textarea" :rows="10" v-model="formData.exp"></el-input>
      </el-form-item>

    </el-form>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {

    const { properties, text } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }

    if (text && text.value) {
      this.$data.formData.text = text.value
    }


  },
  data() {
    return {

      formData: {
        text: '',
        name: '',
        exp:'',
        region: '',
        type: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',

      }

    }
  },
  methods: {
    onSubmit() {
      //console.log('submit!');
      // const { id } = this.$props.nodeData
      // this.$props.lf.setProperties(id, this.$data.form);
      const nodeData = this.$props.nodeData
      nodeData.properties = this.$data.formData
      this.$props.lf.setProperties(nodeData.id, this.$data.formData);
      this.$props.lf.updateText(nodeData.id, this.$data.formData.text);
      this.$emit('onClose')
    }
  }
}
</script>
<style scoped>
</style>
